type Track = {
    svgId: string;
    pathId: string;
    textContent: string;
    numTexts: number;
    animationDuration: number;
    animationOffset?: number;
}

export function createRollingText(track: Track) {
    const svg = document.getElementById(track.svgId);
    if (!svg) { throw new Error(`SVG element with id '${track.svgId}' not found`); }

    const delayIncrement = track.animationDuration / track.numTexts;
    const offset = track.animationOffset || 0;

    for (let i = 0; i < track.numTexts; i++) {
        const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        textElement.setAttribute('class', 'rolling-text');

        const textPath = document.createElementNS('http://www.w3.org/2000/svg', 'textPath');
        textPath.setAttribute('href', `#${track.pathId}`);
        textPath.textContent = track.textContent;

        const animate = document.createElementNS('http://www.w3.org/2000/svg', 'animate');
        animate.setAttribute('attributeName', 'startOffset');
        animate.setAttribute('values', '0%;100%');
        animate.setAttribute('dur', `${track.animationDuration}s`);
        animate.setAttribute('repeatCount', 'indefinite');
        animate.setAttribute('begin', `${-i * delayIncrement + offset}s`);

        textPath.appendChild(animate);
        textElement.appendChild(textPath);
        svg.appendChild(textElement);
    }
}
